import { h, Fragment } from 'preact'

export function Showing({ pagination }) {
	const { firstItemOnPage, lastItemOnPage, totalItems } = pagination

	if (firstItemOnPage === undefined) return ''

	const Range = <b>{`${firstItemOnPage}–${lastItemOnPage}`}</b>
	const Total = <b>{totalItems}</b>

	if (pagination.totalItems === 0) {
		return "No results found"
	}

	if (pagination.totalItems === 1) {
		return <>Showing {Total} role</>
	}

	if (pagination.totalItems === pagination.lastItemOnPage && pagination.firstItemOnPage === 0) {
		return <>Showing all {Total} roles</>
	}

	return <>Showing {Range} of {Total} roles</> 
}